/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ word: NonNullable<unknown>, pronunciation: NonNullable<unknown> }} Pronunciation_Report_MessageInputs */

const en_pronunciation_report_message = /** @type {(inputs: Pronunciation_Report_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Word or phrase: ${i?.word}
Suggested pronunciation: ${i?.pronunciation}`)
};

const es_pronunciation_report_message = /** @type {(inputs: Pronunciation_Report_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Palabra o frase: ${i?.word}
Pronunciación sugerida: ${i?.pronunciation}`)
};

/**
* | output |
* | --- |
* | "Word or phrase: {word} Suggested pronunciation: {pronunciation}" |
*
* @param {Pronunciation_Report_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_message = /** @type {((inputs: Pronunciation_Report_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_message(inputs)
	return en_pronunciation_report_message(inputs)
});